import React from 'react'

const VestigingContext = React.createContext({
    vestiging: '',
    change: '',
});

export default VestigingContext;